import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { COMPLETE_CURRICULUM_VITAE, getErrorUpdateToastPropsBy } from '../../../../service/toastService';
import { getUserInformation } from '../../../../api/usersApi';

export default function PersonalInfo({ currentLoggedUserId, wizardCompleted }) {
    const [personalInfo, setPersonalInfo] = useState(null);

    useEffect(() => {
        const fetchPersonalData = async () => {
            if (!currentLoggedUserId) return;

            try {
                const response = await getUserInformation(currentLoggedUserId);
                setPersonalInfo(response.data);

            } catch (error) {
                toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE));
            }
        };

        fetchPersonalData();
    }, [currentLoggedUserId]);

    return (
        <div>
            {personalInfo && (
                <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div>
                            {!wizardCompleted && (
                                <h4 className="mb-4" style={{textDecoration: 'underline', textUnderlineOffset: '7px'}}>Personal Information</h4>
                            )}
                        </div>
                        <p style={{fontSize: '12px', marginBottom: 0}}>
                            Something missing or incorrect? 
                            <a
                                href={`mailto:info@t4t.rocks?subject=Personal Information incorrect`}
                                className="btn btn-primary"
                                style={{color: 'white', marginLeft: '10px'}}
                            >
                                Contact Admin
                            </a>
                        </p>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="small">FIRST NAME</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.firstName || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">MIDDLE NAME</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.middleName || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">LAST NAME</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.lastName || ''} readOnly />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="small">PHONE NUMBER</label>
                            <input className="form-control" type="text" value={personalInfo.userContactInfo.cellPhone ? personalInfo.userContactInfo.cellPhone : personalInfo.userContactInfo.phone} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label className="small">EMAIL</label>
                            <input className="form-control" type="email" value={personalInfo.userContactInfo.workEmail ?  personalInfo.userContactInfo.workEmail :  personalInfo.userContactInfo.personalEmail} readOnly />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="small">{`DRIVER'S LICENSE B`}</label>
                            <input
                                className="form-check-input ml-3"
                                type="checkbox"
                                checked={personalInfo.userGeneralInfo.hasDriversLicense}
                                style={{ pointerEvents: 'none' }}
                            />                        
                        </div>
                    </div>

                    <div className="section-header mb-3">
                        <h4>Address Details</h4>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="small">STREET NAME</label>
                            <input className="form-control" type="text" value={personalInfo.userAddress.street || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">NUMBER</label>
                            <input className="form-control" type="number" value={personalInfo.userAddress.number || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">BOX NUMBER</label>
                            <input className="form-control" type="text" value={personalInfo.userAddress.boxNumber || ''} readOnly />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="small">ZIP CODE</label>
                            <input className="form-control" type="text" value={personalInfo.userAddress.zipCode || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">CITY</label>
                            <input className="form-control" type="text" value={personalInfo.userAddress.city || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">COUNTRY</label>
                            <input className="form-control" type="text" value={personalInfo.userAddress.country || ''} readOnly />
                        </div>
                    </div>

                    <div className="section-header mb-3">
                        <h4>Extra Information</h4>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="small">DATE OF BIRTH</label>
                            <input className="form-control" type="date" value={personalInfo.userGeneralInfo.dateOfBirth ? new Date(personalInfo.userGeneralInfo.dateOfBirth).toISOString().split('T')[0] : ''} readOnly />
                        </div>
                        <div className="col-md-6">
                            <label className="small">PLACE OF BIRTH</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.placeOfBirth || ''} readOnly />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-4">
                            <label className="small">NATIONALITY</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.nationality || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">GENDER</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.gender || ''} readOnly />
                        </div>
                        <div className="col-md-4">
                            <label className="small">MARITAL STATUS</label>
                            <input className="form-control" type="text" value={personalInfo.userGeneralInfo.maritalStatus || ''} readOnly />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-12">
                            <label className="small">LINKEDIN URL</label>
                            <input className="form-control" type="url" value={personalInfo.userSocials.linkedIn || ''} readOnly />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

